import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form, Col, Row, Button } from "react-bootstrap";
import { get, isArray } from "lodash";
import { Field } from "../fieldComponent";
import {
  createRoleAction,
  getGroupCategoryForRoleAction,
  getRolesAction
} from "../../../actions/userManagement.action";
import { ERROR_MSG, STATUS } from "../../../constant";
import { modifyDataForCreateRole } from "../helper";
import { toast } from "react-toastify";
import { ConfirmationComponent } from "../../ConfirmationComponent";
import { LoaderPage } from "../../../component/Loader";
import Select from "react-select";
import DisplayByPermission from "../../../component/DisplayByPermission";
import { successToastStyle, errorToastStyle } from "../../../customToast";

let delay = 500;
class CreateRoleForm extends Component {
  state = {
    name: "",
    description: "",
    permissionIds: [],
    groupCategories: [],
    preselect: false,
    isEdit: false,
    error: {},
    dataUnsaved: false,
    allowPrompt: true
  };

  componentDidMount() {
    const { isEdit, groupData, getGroupCategoryForRoleAction } = this.props;
    document.addEventListener("mousedown", this.handleClickOutside);
    getGroupCategoryForRoleAction(undefined);
    if (isEdit) {
      this.setState({
        name: get(groupData, "name"),
        description: get(groupData, "description"),
        id: get(groupData, "id"),
        groupCategories: (get(groupData, "groupCategories") || []).map(item => {
          return {
            value: item,
            label: item
          };
        }),
        preselect: get(groupData, "preselect"),
        permissionIds: get(groupData, "permissions", []).map(value => {
          return value.id;
        }),

        error: {
          name: { error: false },
          description: { error: false },
          permissionIds: { error: false },
          groupCategories: { error: false }
        }
      });
    }
  }
  componentWillUnmount() {
    // Clean up the event listener
    document.removeEventListener("mousedown", this.handleClickOutside);
  }
  onBlur = value => {};
  handleClickOutside = event => {
    const { togglePopUp } = this.props;
    const { dataUnsaved, allowPrompt } = this.state;

    // Check if the click was outside the modal
    const modalRef = this.props.roleModelRef && this.props.roleModelRef.current;
    const isOutsideModal = modalRef && !modalRef.contains(event.target);

    // Check if the click was on the vertical scrollbar
    const isClickOnScrollbar =
      event.clientX > window.innerWidth - 7 &&
      (event.clientY >= 0 && event.clientY <= window.innerHeight);

    // If the click is outside the modal and not on the scrollbar
    if (isOutsideModal && !isClickOnScrollbar) {
      console.log(
        "Clicked outside the modal, but modal will not close.",
        dataUnsaved
      );
      if (dataUnsaved && allowPrompt && event.button === 0) {
        event.preventDefault();
        const confirmLeave = window.confirm(
          "You have unsaved changes, are you sure you want to leave?"
        );

        if (confirmLeave) {
          togglePopUp();
          return;
        }
      }
    }
  };

  onChange = (value, key) => {
    this.setState(prevState => {
      if (isArray(prevState[key]) && key !== "groupCategories") {
        const index = prevState[key].indexOf(value);
        index !== -1
          ? prevState[key].splice(index, 1)
          : (prevState[key] = [...prevState[key], value]);
      } else {
        prevState[key] = value;
      }
      return {
        [key]: prevState[key],
        dataUnsaved: true
      };
    });
  };

  onError = (error, key) => {
    this.setState(prevState => {
      const { permissionIds, groupCategories } = prevState;
      return {
        error: {
          ...prevState.error,
          [key]:
            key === "permissionIds"
              ? {
                  error: !permissionIds.length,
                  message:
                    (!permissionIds.length && ERROR_MSG.DEFAULT_MSG) || ""
                }
              : key === "groupCategories"
              ? {
                  error: !groupCategories.length,
                  message:
                    (!groupCategories.length && ERROR_MSG.DEFAULT_MSG) || ""
                }
              : error
        }
      };
    });
  };

  onValidateForm = () => {
    const { error } = this.state;
    if (
      get(error, "name") &&
      !get(error, "name.error") &&
      get(error, "description") &&
      !get(error, "description.error") &&
      get(error, "permissionIds") &&
      !get(error, "permissionIds.error") &&
      get(error, "groupCategories") &&
      !get(error, "groupCategories.error")
    ) {
      this.openConfirmationAlert();
    } else {
      this.setState(prevState => {
        prevState.error.name = {
          error: !prevState.name,
          message: !prevState.name && ERROR_MSG.DEFAULT_MSG
        };
        prevState.error.description = {
          error: !prevState.description,
          message: !prevState.description && ERROR_MSG.DEFAULT_MSG
        };
        prevState.error.permissionIds = {
          error: !prevState.permissionIds.length,
          message: !prevState.permissionIds.length && ERROR_MSG.DEFAULT_MSG
        };
        prevState.error.groupCategories = {
          error: !prevState.groupCategories.length,
          message: !prevState.groupCategories.length && ERROR_MSG.DEFAULT_MSG
        };
        toast.error(
          <p className="toast-text-alignment">{ERROR_MSG.INVALID_FORM}</p>,
          errorToastStyle
        );
        return {
          error: {
            ...prevState.error
          }
        };
      });
    }
  };

  handleSearch = searchValue => {
    const { permissionListing } = this.props;
    const search = RegExp(searchValue.trim(), "i");
    get(permissionListing, "data", []).forEach(value => {
      value.visibility = search.test(value.name) ? "" : "none";
    });
    get(permissionListing, "data") &&
      this.setState({
        search: searchValue
      });
  };

  openConfirmationAlert = () => {
    this.setState(prevState => ({
      showAlert: !prevState.showAlert,
      allowPrompt: !prevState.allowPrompt
    }));
  };

  onSubmit = async () => {
    this.setState({ isApiLoading: STATUS.LOADING });
    const { createRoleDispatch, getRolesDispatch, togglePopUp } = this.props;
    const data = modifyDataForCreateRole(this.state);
    this.openConfirmationAlert();
    togglePopUp();
    const response = await createRoleDispatch(undefined, data);
    if (response) {
      const { status, message } = response;
      if (status) {
        toast.success(
          <p className="toast-text-alignment">{message}</p>,
          successToastStyle
        );
        await getRolesDispatch(undefined);
        this.setState({ isApiLoading: STATUS.SUCCESS, dataUnsaved: false });
      } else {
        toast.error(
          <p className="toast-text-alignment">{message}</p>,
          errorToastStyle
        );
        this.setState({ isApiLoading: STATUS.SUCCESS });
      }
    }
  };

  render() {
    const {
      permissionListing,
      isApiLoading,
      categoryForRoleList,
      permission
    } = this.props;
    const {
      name: stateName,
      description: stateDescription,
      permissionIds: statePermissionIds,
      groupCategories: stateGroupCategory,
      error,
      showAlert,
      search,
      preselect
    } = this.state;
    const { name, description, permissionIds, groupCategories } = error;
    return (
      <React.Fragment>
        <div className="register-inner create-user-register-inner">
          <LoaderPage isLoading={isApiLoading === STATUS.LOADING} />
          <Form name="createGroup" className="create-role-form">
            <ConfirmationComponent
              show={showAlert}
              isLoading={isApiLoading}
              modalClass={"confirmation-modal"}
              saveHandler={this.onSubmit}
              closeHandler={this.openConfirmationAlert}
              content={"Are you sure you want to do this?"}
            />

            <Form.Group as={Row} controlId="formPlaintextEmail">
              <Form.Label className="group-label label-style">
                Name
                <span className="required">*</span>
              </Form.Label>
              <Col>
                <Field
                  type="text"
                  strictType="string"
                  keyName="name"
                  onChange={this.onChange}
                  disabled={get(permission, "canViewOnlyProject")}
                  onError={this.onError}
                  delay={delay}
                  value={stateName || ""}
                  isInvalid={get(name, "error")}
                  isRequired
                  placeholder="Enter your name"
                />
                <Form.Control.Feedback type="invalid">
                  {get(name, "message")}
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formPlaintextEmail">
              <Form.Label className="group-label label-style">
                Description
                <span className="required">*</span>
              </Form.Label>
              <Col>
                <Field
                  type="text"
                  strictType="string"
                  keyName="description"
                  onChange={this.onChange}
                  disabled={get(permission, "canViewOnlyProject")}
                  onError={this.onError}
                  delay={delay}
                  value={stateDescription || ""}
                  isInvalid={get(description, "error")}
                  isRequired
                  placeholder="Type description"
                />
                <Form.Control.Feedback type="invalid">
                  {get(description, "message")}
                </Form.Control.Feedback>
              </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formPlaintextEmail">
              <Form.Label className="group-label label-style">
                Category
                <span className="required">*</span>
              </Form.Label>
              <Col>
                <Select
                  isDisabled={get(permission, "canViewOnlyProject")}
                  defaultValue={stateGroupCategory || []}
                  isMulti
                  name="groupCategories"
                  options={get(categoryForRoleList, "data", [])}
                  className={`basic-multi-select ${
                    get(groupCategories, "error") ? "error-box" : ""
                  } ${get(permission, "canViewOnlyProject") &&
                    "disable-dropdown-field"}`}
                  classNamePrefix={
                    get(permission, "canViewOnlyProject")
                      ? "disable-dropdown-field"
                      : "select"
                  }
                  onBlur={e => this.onError(e, "groupCategories")}
                  isRequired
                  isInvalid={get(groupCategories, "error")}
                  onChange={e => this.onChange(e, "groupCategories")}
                  value={stateGroupCategory || []}
                />
                {get(groupCategories, "error") && (
                  <span className="error">
                    {get(groupCategories, "message")}
                  </span>
                )}
              </Col>
            </Form.Group>

            <Form.Group as={Row} controlId="formBasicCheckbox">
              <Form.Check
                type="checkbox"
                keyName="preselect"
                value={preselect}
                id="preselect"
                label="Pre-Select"
                checked={preselect}
                onChange={e => {
                  this.onChange(e.target.checked, "preselect");
                }}
                disabled={get(permission, "canViewOnlyProject")}
                className={`group-label form-label form-checkbox ${
                  preselect ? `form-checkbox checked` : `form-checkbox`
                }${
                  get(permission, "canViewOnlyProject")
                    ? "checked checked-disable"
                    : ""
                }`}
              />
            </Form.Group>

            <Form.Group as={Row} controlId="formPlaintextPermissions">
              <Form.Label className="group-label label-style">
                Permissions <span className="required">*</span>
                <Form.Group
                  className="search-box permission-search"
                  style={{ marginTop: "6px" }}
                >
                  <Form.Control
                    type="text"
                    placeholder="Search"
                    disabled={get(permission, "canViewOnlyProject")}
                    onChange={e => {
                      this.handleSearch(e.target.value, e);
                    }}
                    value={search}
                    className="search-component"
                  />
                </Form.Group>
              </Form.Label>
              <Col style={{ height: "200px", overflow: "auto" }}>
                {get(permissionListing, "data", []).map(permission => {
                  return (
                    <React.Fragment>
                      <Form.Label aria-label={permission.name} />
                      <Form.Check
                        type="checkbox"
                        keyName="permissionIds"
                        value={permission.id}
                        id={permission.name}
                        label={permission.name}
                        onError={this.onError}
                        checked={
                          statePermissionIds.indexOf(permission.id) !== -1
                        }
                        onChange={() => {
                          this.onChange(permission.id, "permissionIds");
                          this.onError(permission.id, "permissionIds");
                        }}
                        disabled={
                          this.props.isEdit &&
                          this.props.permission.canViewOnlyProject
                        }
                        //onChange={this.onChange}
                        style={{
                          display: permission.visibility
                        }}
                        className={`form-checkbox ${
                          statePermissionIds.indexOf(permission.id) !== -1
                            ? "form-checkbox checked"
                            : "form-checkbox"
                        }${
                          this.props.isEdit &&
                          this.props.permission.canViewOnlyProject
                            ? "form-checkbox checked checked-disable"
                            : ""
                        }`}
                      />

                      <Form.Control.Feedback type="invalid">
                        {get(permissionIds, "message")}
                      </Form.Control.Feedback>
                    </React.Fragment>
                  );
                })}
              </Col>
              {get(permissionIds, "error") && (
                <span class="error">{get(permissionIds, "message")}</span>
              )}
            </Form.Group>
            <DisplayByPermission
              display={!get(permission, "canViewOnlyProject")}
            >
              <Button
                className="btn-orange"
                onClick={this.onValidateForm}
                style={{ borderRadius: "4px" }}
              >
                SUBMIT
              </Button>
            </DisplayByPermission>
          </Form>
        </div>
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    permissionListing: state.userManagementReducer.permissionListing,
    categoryForRoleList: state.userManagementReducer.categoryForRoleList
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      createRoleDispatch: createRoleAction,
      getRolesDispatch: getRolesAction,
      getGroupCategoryForRoleAction
    },
    dispatch
  );
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateRoleForm);
